import { IconButton } from '@/ui/common/Buttons/IconButton';
import { CloseIcon } from '@/ui/common/Icons/CloseIcon';
import { ReactNode } from 'react';

type TToastScreenProps = {
    title: string;
    description: ReactNode;
};

export const ToastScreen = ({ title, description }: TToastScreenProps) => (
    <div className="toast-screen flex h-24 w-[340px] rounded-l-[80px] rounded-r-[15px] px-[9px] py-0 md:h-[108px] md:w-[433px] lg:h-[140px] lg:w-[480px]">
        <IconButton icon={<CloseIcon />} className="absolute right-1 top-1 md:right-2 md:top-2" />
        <div className="flex items-center">
            <div className="pointer-events-none flex min-h-[78px] min-w-[78px] items-center justify-center rounded-full bg-ash dark:bg-blue-1 md:min-h-[92px] md:min-w-[92px] lg:min-h-[120px] lg:min-w-[120px]">
                <div className="min-h-[43px] min-w-[44px] bg-promo-ticket bg-contain bg-no-repeat dark:bg-promo-ticket-dark md:h-[51px] md:w-[52px] lg:h-[67px] lg:w-[68px]" />
            </div>
            <div className="ml-[15px] flex w-full max-w-[220px] flex-col gap-[2px] md:ml-[23px] md:max-w-[268px] md:gap-1 lg:ml-[29px] lg:gap-[9px]">
                <span className="tx-large-semibold text-gray-1 dark:text-white">{title}</span>
                <span className="tx-large-medium text-gray-2 dark:text-gray-3">{description}</span>
            </div>
        </div>
    </div>
);
